import React from 'react';
import ReportFrame from '../ReportFrame';

export default class OperationalSubledgerSummary extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Operational Subledger Summary'
          reportParams={reportParams}
          id='operationalsubledgersummary'
          name='operationalsubledgersummary'
          title='Operational Subledger Summary'
        />
      </div>
    );
  }
}
